// extracted by mini-css-extract-plugin
export default {"caret":"CaretToggle_caret__oIvjR","expanded":"CaretToggle_expanded__PbSdq"};